<ul>
    <li>
        <img src="assets/images/compliance-certificates/hippa.png"
             alt="HIPAA compliance" />
    </li>
    <li>
        <img src="assets/images/compliance-certificates/AICPA_SOC.png"
             alt="AICPA SOC 2" />
    </li>
    <li>
        <img src="assets/images/compliance-certificates/information-security-management-system.svg"
             alt="ISO 27001:2022 Information Security Management System" />
    </li>
    <li>
        <img src="assets/images/compliance-certificates/ferpa.png"
             alt="FERPA compliance" />
    </li>
    <li>
        <img src="assets/images/compliance-certificates/eu-ai-act.png"
             alt="EU AI Act compliance" />
    </li>
    <li>
        <img src="assets/images/compliance-certificates/gdpr.svg"
             alt="General Data Protection Regulation (GDPR)" />
    </li>
    <li>
        <img src="assets/images/compliance-certificates/quality-management-system.svg"
             alt="ISO 9001:2015 Quality Management System" />
    </li>
    <li>
        <img src="assets/images/compliance-certificates/translation-service-requirements.svg"
             alt="ISO 17100 Translation Services Requirements" />
    </li>
    <li>
        <img src="assets/images/compliance-certificates/ada.png"
             alt="Americans with Disabilities Act (ADA) compliance" />
    </li>
</ul>